import axios from "axios";
import AuthClient from "../AuthClient"; 

class GroupInvitationStatusResponse {
    private authClient: AuthClient;

    constructor(authClient: AuthClient) {
        this.authClient = authClient;
    }


    public async updateInvitationStatus(groupId: string, invitationProfileId: string, status: number) {
        const endpoint = `${this.authClient.getApiRoot()}/UpdateInvitationStatus/${groupId}/${invitationProfileId}/${status}`;

        try {
            const response = await axios.post(endpoint, {}, {
                headers: {
                    Authorization: `Bearer ${this.authClient.getAuthenticationResponse()?.token}`,
                },
            });
            console.log("Endpoint URL:", endpoint);
            return response.data;

        } catch (error) {
            console.error('Error updating invitation status:', error);
            throw error;  
        }
    }
}

export default GroupInvitationStatusResponse;
